import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  imports: [CommonModule],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css'
})
export class CheckboxComponent {
    @Input() label: string = '';
    @Input() checkStatusIn: boolean = false;
    @Input() valueIn: any = '';
    @Output() checkStatusOut = new EventEmitter<any>();

    constructor() {
    }

    toggleCheckbox() {
      this.checkStatusIn = !this.checkStatusIn;
      if ( this.valueIn === '' ){
        this.checkStatusOut.emit(this.checkStatusIn);
      }
      else{
        const result : { where : string, result : boolean } = {
          where : this.valueIn,
          result : this.checkStatusIn
        } 
        this.checkStatusOut.emit( result );
      } 
      
      //console.log(this.checkStatusIn , this.checkStatusOut);
    }
    sentData(value: any) {
        this.checkStatusOut.emit(value);
    }
}
